export const ModularInfo = {
  modularName: 'Public'
}

export default {
  // 1.获取微信授权链接 User/Public/getAuthUrl
  getAuthUrl: {
    actionName: 'getAuthUrl'
  },
  // 2.获取验证码 User/Public/getCode
  getCode: {
    actionName: 'getCode'
  },
  // 3.登录 User/Public/login
  login: {
    actionName: 'login'
  },
  // 4.自动登录 User/Public/autoLogin
  autoLogin: {
    actionName: 'autoLogin'
  },
  // 5.用户协议 /User/Public/userAgreement
  userAgreement: {
    actionName: 'userAgreement'
  },
  // 获取首页信息 User/User/index
  index: {
    modularName: 'User',
    actionName: 'index'
  },
  // 退出登陆 User/User/logout
  logout: {
    modularName: 'User',
    actionName: 'logout'
  },
  // 交易记录 /User/Trade/getTradeList
  getTradeList: {
    modularName: 'Trade',
    actionName: 'getTradeList'
  },
  // 押金记录 User/Trade/getDepositList
  getDepositList: {
    modularName: 'Trade',
    actionName: 'getDepositList'
  },
  // 获取模式信息 User/AddCup/getPlanList
  getPlanList: {
    modularName: 'AddCup',
    actionName: 'getPlanList'
  },
  // 获取学校与班级 User/AddCup/getSchool
  getSchool: {
    modularName: 'AddCup',
    actionName: 'getSchool'
  },
  // 提交绑定水杯 User/AddCup/bindCup
  bindCup: {
    modularName: 'AddCup',
    actionName: 'bindCup'
  },
  // 获取关系管理列表 User/Family/getList
  getList: {
    modularName: 'Family',
    actionName: 'getList'
  },
  // 添加亲属 User/Family/addFamily
  addFamily: {
    modularName: 'Family',
    actionName: 'addFamily'
  },
  // 取消关注 User/Family/delFamily
  delFamily: {
    modularName: 'Family',
    actionName: 'delFamily'
  },
  // 获取模式信息 User/Cup/getPlanList
  CupGetPlanList: {
    modularName: 'Cup',
    actionName: 'getPlanList'
  },
  // 退押 User/Cup/returnDeposit
  CupReturnDeposit: {
    modularName: 'Cup',
    actionName: 'returnDeposit'
  },
  // 获取继续订购列表 User/Plan/getPlanByCupId
  CupGetPlanByCupId: {
    modularName: 'Plan',
    actionName: 'getPlanByCupId'
  },
  // 计算 User/Plan/calRenewPlan
  CupCalRenewPlan: {
    modularName: 'Plan',
    actionName: 'calRenewPlan'
  },
  // 提交继续订购 User/Plan/renewPlan
  CupRenewPlan: {
    modularName: 'Plan',
    actionName: 'renewPlan'
  },
  // 模拟支付 User/PayNotify/mockPay
  mockPay: {
    modularName: 'PayNotify',
    actionName: 'mockPay'
  },
  // 获取饮水信息 User/Water/getDrinkInfo
  WaterGetDrinkInfo: {
    modularName: 'Water',
    actionName: 'getDrinkInfo'
  },
  // 查看排名 User/Water/getRankInfo
  WaterGetRankInfo: {
    modularName: 'Water',
    actionName: 'getRankInfo'
  },
  // 获取日统计 User/Water/getDay
  WaterGetDay: {
    modularName: 'Water',
    actionName: 'getDay'
  },
  // 获取周统计 User/Water/getWeek
  WaterGetWeek: {
    modularName: 'Water',
    actionName: 'getWeek'
  },
  // 获取月统计 User/Water/getMonth
  WaterGetMonth: {
    modularName: 'Water',
    actionName: 'getMonth'
  },
  // 挂失 User/Cup/loseCup
  CupLoseCup: {
    modularName: 'Cup',
    actionName: 'loseCup'
  },
  // 重新绑定 User/Cup/reBindCup
  CupReBindCup: {
    modularName: 'Cup',
    actionName: 'reBindCup'
  },
  // 获取学校可购买模式 User/Plan/getPlanBySchoolId
  PlanGetPlanBySchoolId: {
    modularName: 'Plan',
    actionName: 'getPlanBySchoolId'
  },
  // 计算 User/Plan/calBuyPlan
  PlanCalBuyPlan: {
    modularName: 'Plan',
    actionName: 'calBuyPlan'
  },
  // 提交购买 User/Plan/buyPlan
  PlanBuyPlan: {
    modularName: 'Plan',
    actionName: 'buyPlan'
  },
  // User/Public/getWxJssdk/appid/wx049abe1a39cbadb2
  getWxJssdk: {
    modularName: 'Public',
    actionName: 'getWxJssdk/appid/wx049abe1a39cbadb2'
  },
  // 首页编辑班级 /User/User/editClass
  editClass: {
    modularName: 'User',
    actionName: 'editClass'
  },
  // 首页修改学生姓名 /User/User/editStudentName
  editStudentName: {
    modularName: 'User',
    actionName: 'editStudentName'
  },
  // 获取是否停用用水模版消息 /User/User/getTemplate
  getTemplate: {
    modularName: 'User',
    actionName: 'getTemplate'
  },
  // 停用用水模版消息 /User/User/stopTemplate
  stopTemplate: {
    modularName: 'User',
    actionName: 'stopTemplate'
  },
  // 启用用水模版消息 /User/User/startTemplate
  startTemplate: {
    modularName: 'User',
    actionName: 'startTemplate'
  }
}
